module.exports = __webpack_public_path__ + "static/media/IHCA_4-color400.efc9c081.png";